import 'element-closest';
import { TweenLite } from 'gsap';
import { ANIMATIONS } from '../config';

class Accordion {

  constructor(options = {}) {
    this.$root = options.element;
    this.$headers = this.$root.querySelectorAll('.accordion-entry__header');
    this.$entries = this.$root.querySelectorAll('.accordion-entry');
    this.isInitialized = false;
  }

  // noinspection JSUnusedGlobalSymbols: used via reflection
  init() {
    if (!this.isInitialized) {
      this.isInitialized = true;
      this.bindEvents();

      Array.prototype.slice.call(this.$entries).forEach(($entry) => {
        if ($entry.classList.contains('accordion-entry--open')) {
          const $currentContent = $entry.querySelector('.accordion-entry__header').nextElementSibling;
          const $currentIconPlus = $entry.querySelector('.accordion-entry__icon-plus');
          const $currentIconMinus = $entry.querySelector('.accordion-entry__icon-minus');
          Accordion.openContentInitially($currentContent, $currentIconPlus, $currentIconMinus);
        }
      });
    }
  }

  /**
   * bind onClick event to each accordion entry header
   */
  bindEvents() {

    Array.prototype.slice.call(this.$headers).forEach(($header) => {
      const $head = $header;
      if ($head.dataset.hasClickListener) {
        // A parent already has setup listener, don't do it again.
        return;
      }

      $head.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault(); // don't scroll to beginning of site

        const $currentEntry = event.target.closest('.accordion-entry');
        const $currentContent = event.target.closest('.accordion-entry__header').nextElementSibling;
        const $currentIconPlus = $currentEntry.querySelector('.accordion-entry__icon-plus');
        const $currentIconMinus = $currentEntry.querySelector('.accordion-entry__icon-minus');

        $currentContent.classList.add('accordion-entry__content--animating');

        if ($currentEntry.classList.contains('accordion-entry--open')) {
          Accordion.closeContent($currentContent, $currentIconPlus, $currentIconMinus, () => {
            $currentEntry.classList.toggle('accordion-entry--open');
            $currentContent.classList.remove('accordion-entry__content--animating');
          });
        } else {
          $currentEntry.classList.toggle('accordion-entry--open');
          Accordion.openContent($currentContent, $currentIconPlus, $currentIconMinus, () => {
            $currentContent.classList.remove('accordion-entry__content--animating');
          });
        }
      }, true);

      $head.dataset.hasClickListener = true;
    });
  }

  /**
   * Animate "+" to "-"
   * Animate height of content expanding
   * @param $content
   * @param $iconPlus
   * @param $iconMinus
   * @param animationCallback
   */
  static openContent($content, $iconPlus, $iconMinus, animationCallback) {
    TweenLite.to($iconPlus, ANIMATIONS.default.DURATION, {
      ease: ANIMATIONS.default.CURVE,
      scaleX: 0,
    });

    TweenLite.to($iconMinus, ANIMATIONS.default.DURATION, {
      ease: ANIMATIONS.default.CURVE,
      scaleX: 0.125,
    });

    TweenLite.to($iconMinus, ANIMATIONS.default.DURATION, {
      delay: ANIMATIONS.default.DURATION,
      ease: ANIMATIONS.default.CURVE,
      scaleX: 1,
    });

    TweenLite.set($content, {
      height: 'auto',
    });

    TweenLite.from($content, ANIMATIONS.default.DURATION * 2, {
      ease: ANIMATIONS.default.CURVE,
      height: 0,
      onComplete: animationCallback,
    });
  }

  /**
   * Set "+" to "-"
   * Set height to height of expanded content
   * @param $content
   * @param $iconPlus
   * @param $iconMinus
   */
  static openContentInitially($content, $iconPlus, $iconMinus) {
    TweenLite.set($iconPlus, {
      scaleX: 0,
      x: -8,
      y: -8,
    });

    TweenLite.set($iconMinus, {
      scaleX: 0.125,
      x: -8,
      y: -8,
    });

    TweenLite.set($iconMinus, {
      scaleX: 1,
      x: -8,
      y: -8,
    });

    TweenLite.set($content, {
      height: 'auto',
    });
  }

  /**
   * Animate "-" to "+"
   * Animate height of content collapsing
   * @param $content
   * @param $iconPlus
   * @param $iconMinus
   * @param animationCallback
   */
  static closeContent($content, $iconPlus, $iconMinus, animationCallback) {
    TweenLite.to($iconPlus, ANIMATIONS.default.DURATION, {
      ease: ANIMATIONS.default.CURVE,
      scaleX: 0.125,
    });

    TweenLite.to($iconPlus, ANIMATIONS.default.DURATION, {
      delay: ANIMATIONS.default.DURATION,
      ease: ANIMATIONS.default.CURVE,
      scaleX: 1,
    });

    TweenLite.to($iconMinus, ANIMATIONS.default.DURATION, {
      ease: ANIMATIONS.default.CURVE,
      scaleX: 0.125,
    });

    TweenLite.to($iconMinus, ANIMATIONS.default.DURATION, {
      delay: ANIMATIONS.default.DURATION,
      ease: ANIMATIONS.default.CURVE,
      scaleX: 1,
    });

    TweenLite.to($content, ANIMATIONS.default.DURATION * 2, {
      ease: ANIMATIONS.default.CURVE,
      height: 0,
      onComplete: animationCallback,
    });

    Accordion.pauseVideos($content);
  }

  /**
   * Pauses all Youtube videos inside of $content
   * @param $content
   */
  static pauseVideos($content) {
    const $videos = $content.querySelectorAll('.videoplayer iframe');
    Array.prototype.slice.apply($videos).forEach(($video) => {
      $video.contentWindow.postMessage(JSON.stringify({ event: 'command', func: 'pauseVideo', args: '' }), '*'); // pause youtube video
    });
  }

}

export default Accordion;



// WEBPACK FOOTER //
// ./src/javascript/main/MD103_Akkordeon/index.js